import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root', 
})
export class DateFormatterService {

  constructor(private datePipe: DatePipe) {}

  formatDate(apiDate: { seconds: number; nanoseconds: number }, format: string = 'dd.MM.yyyy'): any  {
    if(apiDate) {
      const date = new Date(apiDate.seconds * 1000); // Convert seconds to milliseconds
      return this.datePipe.transform(date, format);
    }
  }
    // Format date for form input (returns 'yyyy-MM-dd')
    formatForInput(apiDate: { seconds: number; nanoseconds: number }): string | null {
      if (apiDate) {
        const date = new Date(apiDate.seconds * 1000);
        return this.datePipe.transform(date, 'yyyy-MM-dd'); // Required format for input type="date"
      }
      return null;
    }

  // Generic helpers used across components
  // Format a Date to local 'YYYY-MM-DD' string for date inputs
  formatLocalDateForInput(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // Parse a 'YYYY-MM-DD' string into a local Date at midnight
  parseLocalDateFromInput(input: string): Date {
    const [yearStr, monthStr, dayStr] = input.split('-');
    const year = Number(yearStr);
    const monthIndex = Number(monthStr) - 1; // zero-based month
    const day = Number(dayStr);
    return new Date(year, monthIndex, day, 0, 0, 0, 0);
  }

  // Convert ISO or date-like string to local HH:mm
  formatTime(isoString: string): string {
    const date = new Date(isoString);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  // Combine a 'YYYY-MM-DD' date and 'HH:mm' time into an ISO string (UTC)
  combineDateAndTime(date: string, time: string): string {
    const [hours, minutes] = time.split(':');
    const dateOnly = this.parseLocalDateFromInput(date);
    dateOnly.setHours(Number(hours), Number(minutes), 0, 0);
    return dateOnly.toISOString();
  }

  // Format a date range for display with smart year handling
  formatRangeForDisplay(start: Date, end: Date): string {
    const optionsSameYear: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' };
    const optionsWithYear: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' };

    if (start.getFullYear() === end.getFullYear()) {
      if (start.getMonth() === end.getMonth()) {
        return `${start.toLocaleDateString('en-US', optionsSameYear)} - ${end.toLocaleDateString('en-US', optionsWithYear)}`;
      }
      return `${start.toLocaleDateString('en-US', optionsSameYear)} - ${end.toLocaleDateString('en-US', optionsWithYear)}`;
    }
    return `${start.toLocaleDateString('en-US', optionsWithYear)} - ${end.toLocaleDateString('en-US', optionsWithYear)}`;
  }
}
